<router-outlet></router-outlet>
<div class="backdrop" [ngClass]="{ show: loadingFacade.loading$ | async }">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
